<template>
  <b-modal header-class="ion-bg-modal-header" size="xl"
           centered scrollable no-close-on-backdrop
           v-model="visible">

    <template #modal-header>
      <div class="fw-bold">{{ $t('plan.memberPlanTitle') }} {{ $t('common.edit') }}</div>
    </template>

    <div class="row">
      <div class="col-xl-12">

        <div class="row mb-3">
          <div class="col-xl-6">
            <label class="form-label" for="member-plan-update-name">{{ $t('plan.planName') }}</label>
            <b-form-input class="form-control" type="text" id="member-plan-update-name" v-model="form.planName" disabled />
          </div>
          <div class="col-xl-6"></div>
        </div>
        <div class="row mb-3">
          <div class="col-xl-12">
            <label class="form-label" for="member-plan-update-description">
              <span>{{ $t('plan.description') }}</span>
              <i class="uil uil-asterisk text-danger ms-1"></i>
            </label>
            <b-form-input class="form-control"
                          type="text"
                          id="member-plan-update-description"
                          v-model="form.description"
                          :class="{ 'is-invalid': submitted && $v.form.description.$error }" />
            <div v-if="submitted && $v.form.description.$error" class="invalid-feedback">
              <span v-if="!$v.form.description.required">{{ $t('validation.planDescIsRequired') }}</span>
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-xl-6">
            <label class="form-label" for="member-plan-update-discountRate">
              <span>{{ $t('plan.discountRate') }}</span>
              <i class="uil uil-asterisk text-danger ms-1"></i>
            </label>
            <b-form-input class="form-control"
                          type="text"
                          id="member-plan-update-discountRate"
                          v-model="form.discountRate"
                          :class="{ 'is-invalid': submitted && $v.form.discountRate.$error }" />
            <div v-if="submitted && $v.form.discountRate.$error" class="invalid-feedback">
              <span v-if="!$v.form.discountRate.required">{{ $t('validation.discountRateIsRequired') }}</span>
            </div>
          </div>
          <div class="col-xl-6" v-if="planId === 10000000000031">
            <label class="form-label" for="member-plan-update-fee">
              <span>{{ $t('plan.monthlyFee') }}</span>
              <i class="uil uil-asterisk text-danger ms-1"></i>
            </label>
            <b-form-input class="form-control"
                          type="text"
                          id="member-plan-update-fee"
                          v-model="form.monthlyFee"
                          :class="{ 'is-invalid': submitted && $v.form.monthlyFee.$error }" />
            <div v-if="submitted && $v.form.monthlyFee.$error" class="invalid-feedback">
              <span v-if="!$v.form.monthlyFee.required">{{ $t('validation.monthlyFeeIsRequired') }}</span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <template #modal-footer>
      <div class="w-100 text-end">
        <b-button variant="secondary" class="w-xs p-1 me-3" @click="close">{{ $t('btn.close') }}</b-button>
        <b-button variant="success" class="w-xs p-1" @click="save">{{ $t('btn.save') }}</b-button>
      </div>
    </template>

  </b-modal>
</template>

<script>
import { http } from '@/auth-api';
import i18n from '@/i18n';
import Swal from 'sweetalert2';
import { required } from 'vuelidate/lib/validators';

export default {
  props: {
    selectedId: {
      type: Number
    }
  },
  data() {
    return {
      planId: null,
      visible: false,
      submitted: false,
      form: {
        planName: null,
        discountRate: null,
        description: null,
        monthlyFee: null
      }
    }
  },
  validations: {
    form: {
      description: { required },
      discountRate: { required },
      monthlyFee: { required }
    }
  },
  methods: {
    show() {
      const vm = this;

      vm.planId = this.selectedId;
      vm.getItem();
      vm.visible = true;
    },
    getItem() {
      const vm = this;
      const _url = `/onmapi/view/MemberPlan/retrieve/${this.selectedId}`;

      http.get(_url).then((res) => {
        vm.item = res.data.item;
        vm.form = Object.assign({}, vm.item);
      }).catch((err) => {
        console.error('Member Plan Retrieve Error !!', err)
      });
    },
    close() {
      const vm = this;

      this.$emit('callback');
      vm.resetForm();
      vm.visible = false;
    },
    resetForm() {
      const vm = this;

      vm.form = {
        planName: null,
        discountRate: null,
        description: null,
        monthlyFee: null
      }

      vm.$nextTick(() => {
        this.$v.$reset();
      });
    },
    save() {
      const vm = this;
      vm.submitted = true;

      this.$v.$touch();

      if (!this.$v.$invalid) {
        Swal.fire({
          title: i18n.t('alert.confirmEdit'),
          showCancelButton: true,
          confirmButtonText: i18n.t('btn.ok'),
          cancelButtonText: i18n.t('btn.cancel')
        }).then((result) => {
          if (result.isConfirmed) {
            vm.saveItems();
          }
        });
      }
    },
    saveItems() {
      const vm = this;
      const _url = '/onmapi/view/MemberPlan/update';

      let _form = {
        memberPlanId: this.selectedId,
        planName: vm.form.planName,
        discountRate: vm.form.discountRate,
        description: vm.form.description,
        monthlyFee: vm.form.monthlyFee
      };

      http.patch(_url, _form).then(res => {
        if (res) {
          Swal.fire({
            icon: 'info',
            title: i18n.t('alert.edited'),
            confirmButtonText: i18n.t('btn.close')
          });
          vm.close();
        }
      }).catch(err => {
        console.error('Member Plan Edit Error :: ', err)

        Swal.fire({
          icon: 'error',
          title: i18n.t('alert.error'),
          confirmButtonText: i18n.t('btn.close')
        });
      });
    }
  }
}
</script>
